import React from 'react'
import ImageUploading from "react-images-uploading";

// NOTE: this used to keep images ONLY in local state — it never read
// props.value nor called props.onChangeText, so photos added on web were
// silently lost on save. Now controlled from props.value using the same
// format as mobile: an array of raw base64 strings (no data-URL prefix).
export default ({ header, prop, value, onChangeText, viewOnly }) => {

  const stored = Array.isArray(value) ? value : [];
  // react-images-uploading wants [{data_url}] — adapt from raw base64.
  const imageList = stored.map((b64) => ({ data_url: `data:image/jpeg;base64,${b64}` }));

  const commit = (list) => {
    if (!onChangeText) return;
    const raw = list
      .map((img) => (img.data_url || '').replace(/^data:image\/[a-zA-Z+]+;base64,/, ''))
      .filter(Boolean);
    onChangeText(prop, raw);
  };

  return (
    <div style={{ margin: '12px 0' }}>
      {header && <div style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--text-secondary, #5a6b7b)', marginBottom: 4 }}>{header}</div>}
      <ImageUploading
        multiple
        value={imageList}
        onChange={commit}
        maxNumber={69}
        dataURLKey="data_url"
      >
        {({
          imageList: list,
          onImageUpload,
          onImageRemoveAll,
          onImageUpdate,
          onImageRemove,
          isDragging,
          dragProps,
        }) => (
          <div>
            {!viewOnly && (
              <div
                onClick={onImageUpload}
                {...dragProps}
                style={{
                  padding: list.length ? '12px 16px' : '22px 16px',
                  borderRadius: 12,
                  border: `1.5px dashed ${isDragging ? 'var(--primary, #0DA1B2)' : 'rgba(13,161,178,0.35)'}`,
                  background: isDragging ? 'rgba(13,161,178,0.10)' : 'rgba(255,255,255,0.45)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
                  cursor: 'pointer', color: 'var(--text-secondary, #5a6b7b)', fontSize: 13, fontWeight: 600,
                  transition: 'border-color .15s ease, background .15s ease',
                }}
              >
                <i className="fas fa-camera" style={{ color: 'var(--primary, #0DA1B2)' }}></i>
                {isDragging ? 'Drop to add' : 'Click or drop photos here'}
              </div>
            )}

            {list.length > 0 && (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginTop: 10 }}>
                {list.map((image, index) => (
                  <div key={index} style={{ position: 'relative', width: 104 }}>
                    <img
                      src={image.data_url}
                      alt=""
                      style={{ width: 104, height: 104, objectFit: 'cover', borderRadius: 10, border: '1px solid rgba(15,31,46,0.10)', display: 'block' }}
                    />
                    {!viewOnly && (
                      <div style={{ position: 'absolute', top: 4, right: 4, display: 'flex', gap: 4 }}>
                        <button type="button" title="Replace" onClick={() => onImageUpdate(index)} style={{ width: 24, height: 24, borderRadius: 7, border: 'none', cursor: 'pointer', background: 'rgba(255,255,255,0.92)', color: 'var(--text-secondary)', fontSize: 11, boxShadow: '0 1px 4px rgba(15,31,46,0.25)' }}>
                          <i className="fas fa-sync-alt"></i>
                        </button>
                        <button type="button" title="Remove" onClick={() => onImageRemove(index)} style={{ width: 24, height: 24, borderRadius: 7, border: 'none', cursor: 'pointer', background: 'rgba(255,255,255,0.92)', color: 'var(--danger, #DA4A4F)', fontSize: 11, boxShadow: '0 1px 4px rgba(15,31,46,0.25)' }}>
                          <i className="fas fa-times"></i>
                        </button>
                      </div>
                    )}
                  </div>
                ))}
                {!viewOnly && list.length > 1 && (
                  <button type="button" onClick={onImageRemoveAll} style={{ alignSelf: 'flex-start', border: '1px solid rgba(218,74,79,0.30)', background: 'rgba(218,74,79,0.08)', color: 'var(--danger, #DA4A4F)', borderRadius: 8, padding: '5px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                    Remove all
                  </button>
                )}
              </div>
            )}
          </div>
        )}
      </ImageUploading>
    </div>
  );
}
